module.exports = __webpack_public_path__ + "static/media/ULD.0ec016fa.png";